import { mapKeys } from 'lodash';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { hasAuthResponseError, redirectOnLoginPage } from 'Utils/ple-utils';
import { CUSTOMER_ACCOUNT_GET_PAST_TRIPS } from 'Utils/request/requestDictionary';
import type {
  CustomerBookingsQueryOptions,
  CustomerBookingsQueryParams,
} from 'Views/account/queries/account.queries';
import { getCustomerBookingsQuery } from 'Views/account/queries/account.queries';
import type { BookingsState } from './StaysView.reducer';
import './StaysView.reducer';
export const fetchBookings = (
  appContext: AppContext,
  params: CustomerBookingsQueryParams,
  options: CustomerBookingsQueryOptions,
): Promise<{
  customerBookings: PaginatedBookings;
}> =>
  graphQLClient.runNoCacheQuery(getCustomerBookingsQuery(appContext, params, options), appContext, {
    requestName: CUSTOMER_ACCOUNT_GET_PAST_TRIPS,
  });
export const handleUnauthenticated =
  (appContext: AppContext, location: any) =>
  (err: APIError): void => {
    if (hasAuthResponseError(err)) {
      redirectOnLoginPage({
        locale: appContext.locale,
        redirectPath: location.pathname,
      });
    }
  };

const renamingKeys: (arg0: any, arg1: string) => string = (_value, key) =>
  key === 'data' ? 'bookings' : key;

export const flattenBookings = (bookings: BookingsState) =>
  mapKeys({ ...bookings?.meta, data: bookings?.data }, renamingKeys);
